/** Persistent anonymous session (playerId + nickname + signed token). */
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { api } from "../lib/api.js";

interface SessionState {
  token: string | null;
  playerId: string | null;
  nickname: string | null;
  /** Ensure a session exists, creating one with `nickname` if needed. */
  ensure: (nickname: string) => Promise<void>;
  setNickname: (nickname: string) => Promise<void>;
}

export const useSession = create<SessionState>()(
  persist(
    (set, get) => ({
      token: null,
      playerId: null,
      nickname: null,
      async ensure(nickname: string) {
        const { token } = get();
        if (token) {
          if (nickname && nickname !== get().nickname) await get().setNickname(nickname);
          return;
        }
        const res = await api.createSession(nickname);
        set({ token: res.token, playerId: res.playerId, nickname: res.nickname });
      },
      async setNickname(nickname: string) {
        const { token } = get();
        if (!token) {
          const res = await api.createSession(nickname);
          set({ token: res.token, playerId: res.playerId, nickname: res.nickname });
          return;
        }
        const res = await api.updateNickname(nickname, token);
        set({ token: res.token, playerId: res.playerId, nickname: res.nickname });
      },
    }),
    { name: "msf-session" },
  ),
);
